<template>
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.60059 0.783813V11.6718" stroke="#212135" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M14.2669 5.32049L9.60026 0.783813L4.93359 5.32049" stroke="#212135" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18.0002 11.6719V15.3013C18.0002 15.7826 17.8035 16.2441 17.4535 16.5844C17.1034 16.9248 16.6286 17.116 16.1335 17.116H3.06686C2.57179 17.116 2.097 16.9248 1.74693 16.5844C1.39686 16.2441 1.2002 15.7826 1.2002 15.3013V11.6719"
            stroke="#212135" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg></template>